'use client'

interface SubscriptionWarningModalProps {
  isOpen: boolean
  onContinue: () => void
  onGoToPortal: () => void
}

export default function SubscriptionWarningModal({
  isOpen,
  onContinue,
  onGoToPortal,
}: SubscriptionWarningModalProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 animate-fade-in">
        <div className="text-center mb-6">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 mb-4">
            <svg
              className="h-6 w-6 text-yellow-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">
            Assinatura Ativa Detectada
          </h3>
          <p className="mt-2 text-sm text-gray-600">
            Você possui uma assinatura ativa conosco. Deseja realmente criar agendamentos avulsos?
          </p>
          <p className="mt-3 text-sm text-gray-700 font-medium">
            Agendamentos criados por esse portal serão cobrados no ato.
          </p>
        </div>
        <div className="flex flex-col gap-3">
          <button
            onClick={onContinue}
            className="w-full inline-flex justify-center rounded-lg border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:text-sm transition-colors"
          >
            Continuar (Criar Avulso)
          </button>
          <button
            onClick={onGoToPortal}
            className="w-full inline-flex justify-center rounded-lg border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:text-sm transition-colors"
          >
            Ir para Portal de Clientes
          </button>
        </div>
      </div>
    </div>
  )
}

